import { render, staticRenderFns } from "./RiskAssessmentTable.vue?vue&type=template&id=8dee8ffa"
import script from "./RiskAssessmentTable.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports